import { render, staticRenderFns } from "./SubsInput.vue?vue&type=template&id=e1a3e672&scoped=true"
import script from "./SubsInput.vue?vue&type=script&lang=js"
export * from "./SubsInput.vue?vue&type=script&lang=js"
import style0 from "./SubsInput.vue?vue&type=style&index=0&id=e1a3e672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a3e672",
  null
  
)

export default component.exports